export default {
    props: {
        filesFileExtension: {
            type: String,
            kComposite: 'files.file.extension'
        }, 
        filesFileName: {
            type: String,
            kComposite: 'files.file.name'
        }, 
        filesFileSize: {
            type: Number,
            kComposite: 'files.file.size'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-upload-vue-wrapper/src/KendoUpload/Files.js